import React, { FunctionComponent, RefObject } from 'react';
import { Paginate } from '../../molecules/paginate';
import { Loading } from '../../atoms/loading';
import { CompanyListItem } from '../../atoms/companyListItem';
import type { Props as ComponentProps } from './types';

type Props = ComponentProps & {
  dropdownRef: RefObject<HTMLDivElement>;
  isDropdownOpen: boolean;
  toggleDropdown: () => void;
  getSortButtonText: () => string;
  handleSortChange: (sortOption: ComponentProps['sortBy']) => void;
};

const PAGINATE_PER = 20;

export const Presentation: FunctionComponent<Props> = (props) => {
  const displayedCount =
    props.currentPage === props.totalPages
      ? props.totalCount
      : Math.min(props.currentPage * props.itemsPerPage, props.totalCount);

  const paginatedCompanyIds = (() => {
    if (props.currentPage > 1) {
      return props.companyIds.slice((props.currentPage - 1) * PAGINATE_PER, props.currentPage * PAGINATE_PER);
    } else {
      return props.companyIds.slice(0, PAGINATE_PER);
    }
  })();

  const shouldShowPagination = props.companyIds.length !== 0 && Math.ceil(props.companyIds.length / PAGINATE_PER) > 1;

  return (
    <div className="new-companies-list-wrapper">
      <div className="new-companies-list">
        <div className="new-companies-list__header">
          <span className="new-companies-list__count">
            <span className="new-companies-list__count--current">{displayedCount}</span>
            <span className="new-companies-list__count--separator">/</span>
            <span className="new-companies-list__count--total">{props.totalCount}</span>
          </span>
          <div className="new-companies-list__sort" ref={props.dropdownRef}>
            <button
              onClick={props.toggleDropdown}
              className={`new-companies-list__sort-button ${props.isDropdownOpen ? 'active' : ''}`}
            >
              <span className="material-symbols-outlined sort">sort</span>
              {props.getSortButtonText()}
              <span className={`material-symbols-outlined arrows ${props.isDropdownOpen ? 'active' : ''}`}>
                expand_more
              </span>
            </button>
            {props.isDropdownOpen && (
              <div className="selections gtm-sort-view-count" data-event-name='sort on screen' data-category={props.dataCategory} data-value={props.dataValue.companiesSort}>
                <p
                  className={props.sortBy === 'recruitment_desc' ? 'active' : ''}
                  onClick={() => props.handleSortChange('recruitment_desc')}
                  data-event="click"
                  data-category={props.dataCategory}
                  data-value={props.dataValue.sortRecruitment}
                >
                  求人件数順
                  {props.sortBy === 'recruitment_desc' && (
                    <span className="material-symbols-outlined check">check</span>
                  )}
                </p>
                <p
                  className={props.sortBy === 'event_desc' ? 'active' : ''}
                  onClick={() => props.handleSortChange('event_desc')}
                  data-event="click"
                  data-category={props.dataCategory}
                  data-value={props.dataValue.sortEvent}
                >
                  イベント件数順
                  {props.sortBy === 'event_desc' && <span className="material-symbols-outlined check">check</span>}
                </p>
                <p
                  className={props.sortBy === 'story_desc' ? 'active' : ''}
                  onClick={() => props.handleSortChange('story_desc')}
                  data-event="click"
                  data-category={props.dataCategory}
                  data-value={props.dataValue.sortStory}
                >
                  ストーリー件数順
                  {props.sortBy === 'story_desc' && <span className="material-symbols-outlined check">check</span>}
                </p>
              </div>
            )}
          </div>
        </div>

        <ul className="new-companies-list__items">
          {Array.isArray(paginatedCompanyIds) && paginatedCompanyIds.length > 0 // companyIds が空でないことを確認
            ? paginatedCompanyIds.map((companyId) => (
                <li className={`new-companies-list__item ${props.loading ? 'loading' : ''}`} key={companyId}>
                  <CompanyListItem
                    companyId={String(companyId)}
                    user={props.user}
                    noCompanyIcon={props.noCompanyIcon}
                    dataCategory={props.dataCategory}
                    dataValue={props.dataValue}
                    lineIcon={props.lineIcon}
                  />
                </li>
              ))
            : !props.loading &&
              props.totalCount === 0 && (
                <li className="no-result">
                  <h3 className='no-result__title'>該当する会社が見つかりませんでした</h3>
                  <p className='no-result__content'>条件を変更して気になる会社を探してみましょう。</p>
                </li>
              )}
          {props.loading && (
            <div className="l-articles__loading-overlay nobg">
              <Loading />
            </div>
          )}
        </ul>

        {shouldShowPagination && (
          <Paginate
            current={props.currentPage}
            max={Math.ceil(props.companyIds.length / PAGINATE_PER)}
            page="companyIndex"
            handleClick={(page: number) => props.onPageChange(page)}
          />
        )}
      </div>
    </div>
  );
};
